import { MprcCard } from "components";
import * as React from "react";

interface IProps {
    children?: React.ReactNode;
    minWitdh?: string;
    borderRadius?: "none" | "xs" | "sm" | "md" | "lg";
    topBorderRadius?: "default" | "none";
}

export const MprcFilterBox: React.FC<IProps> = ({ children, minWitdh, borderRadius = "md", topBorderRadius = "default" }) => {

    return (
        <MprcCard
            paperColor={["paper", "dark"]}
            borderRadius={borderRadius}
            sx={(theme) => (
                {
                    borderTopLeftRadius: topBorderRadius == "none" ? 0 : undefined,
                    borderTopRightRadius: topBorderRadius == "none" ? 0 : undefined,
                    padding: theme.spacing(1),
                    minWidth: minWitdh ?? "inherit",
                })
            }
        >
            {children}
        </MprcCard>
    );
};
